import PBService from "@irati/utils/services"
import client, {QueryOptions, MutationOptions} from "@irati/utils/services/apollo"
import {
  MutationAcceptRenewalQuoteArgs,
  MutationCancelRenewalQuoteArgs,
  MutationResendRenewalContractArgs,
  MutationAcceptRenewalUpsellArgs,
  MutationSalesNotifyCtaScreenSeenArgs
} from "@irati/types/ops"

import getRenewalQuoteStatus, {getRenewalQuoteStatusKey} from "./queries/getRenewalQuoteStatus"
import getRenewalQuote, {getRenewalQuoteKey} from "./queries/getRenewalQuote"
import previewRenewalQuote, {previewRenewalQuoteKey} from "./queries/previewRenewalQuote"
import acceptRenewalQuote, {acceptRenewalQuoteKey} from "./mutations/acceptRenewalQuote"
import cancelRenewalQuote, {cancelRenewalQuoteKey} from "./mutations/cancelRenewalQuote"
import resendRenewalContract, {resendRenewalContractKey} from "./mutations/resendRenewalContract"
import acceptRenewalUpsell, {acceptRenewalUpsellKey} from "./mutations/acceptRenewalUpsell"
import notifyCTAScreenSeen, {notifyCTAScreenSeenKey} from "./mutations/notifyCTAScreenSeen"

class Service extends PBService {
  getRenewalQuoteStatus(businessId: string, options: QueryOptions = {}) {
    const variables = {businessId}
    return client.query({...options, query: getRenewalQuoteStatus, variables}).then(({data}) => data[getRenewalQuoteStatusKey])
  }

  getRenewalQuote(businessId: string, options: QueryOptions = {}) {
    const variables = {businessId}
    return client.query({...options, query: getRenewalQuote, variables}).then(({data}) => data[getRenewalQuoteKey])
  }

  acceptRenewalQuote(variables: MutationAcceptRenewalQuoteArgs, options: MutationOptions = {}) {
    return client.mutate({...options, mutation: acceptRenewalQuote, variables}).then(({data}) => data[acceptRenewalQuoteKey])
  }

  cancelRenewalQuote(variables: MutationCancelRenewalQuoteArgs, options: MutationOptions = {}) {
    return client.mutate({...options, mutation: cancelRenewalQuote, variables}).then(({data}) => data[cancelRenewalQuoteKey])
  }

  previewRenewalQuote(variables: MutationAcceptRenewalQuoteArgs, options: MutationOptions = {}) {
    return client.mutate({...options, mutation: previewRenewalQuote, variables}).then(({data}) => data[previewRenewalQuoteKey])
  }

  resendRenewalContract(variables: MutationResendRenewalContractArgs, options: MutationOptions = {}) {
    return client.mutate({...options, mutation: resendRenewalContract, variables}).then(({data}) => data[resendRenewalContractKey])
  }

  acceptRenewalUpsell(variables: MutationAcceptRenewalUpsellArgs, options: MutationOptions = {}) {
    return client.mutate({...options, mutation: acceptRenewalUpsell, variables}).then(({data}) => data[acceptRenewalUpsellKey])
  }

  notifyCTAScreenSeen(variables: MutationSalesNotifyCtaScreenSeenArgs, options: MutationOptions = {}) {
    return client.mutate({...options, mutation: notifyCTAScreenSeen, variables}).then(({data}) => data[notifyCTAScreenSeenKey])
  }
}

const service = new Service({errorHandlers: []})

export default service
